// Receipt progress is independent of approval, sending and delivery-note checks.
export const RECEIPT_STATUS_META = {
  pending: { label: "Pending receipt", tone: "pending" },
  partial: { label: "Partially received", tone: "warning" },
  received: { label: "Received", tone: "success" },
  received_with_cancellations: { label: "Received with cancellations", tone: "warning" },
  cancelled: { label: "Receipt cancelled", tone: "cancelled" },
};

export function orderReceiptStatus(order) {
  const lines = (order.lines || []).map((line) => {
    const ordered = Math.max(Number(line.quantity) || 0, 0);
    const received = Math.max(Number(line.quantity_received) || 0, 0);
    const cancelled = Math.max(Number(line.quantity_cancelled) || 0, 0);
    return { ordered, received, cancelled,
      pending: Number(Math.max(ordered - received - cancelled, 0).toFixed(8)) };
  }).filter((line) => line.ordered > 0 || line.received > 0);
  if (!lines.length) return null;
  const received = lines.some((line) => line.received > 0);
  const pending = lines.some((line) => line.pending > 0);
  const cancelled = lines.some((line) => line.cancelled > 0);
  if (received) return pending ? "partial" : cancelled ? "received_with_cancellations" : "received";
  return pending ? "pending" : cancelled ? "cancelled" : null;
}
